var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.485 4.364a.515.515 0 0 0 0-.212.606.606 0 0 0-.34-.449L9.267.067a.606.606 0 0 0-.51 0L.88 3.703a.606.606 0 0 0-.334.418.545.545 0 0 0-.03.243V9.03A10.867 10.867 0 0 0 8.77 19.394a.606.606 0 0 0 .23 0h.085a.606.606 0 0 0 .145 0A10.867 10.867 0 0 0 17.485 9.03V4.364zM9.09 18.182h-.182a9.624 9.624 0 0 1-7.182-9.14V4.655L9 1.273l7.273 3.382V9.042a9.624 9.624 0 0 1-7.182 9.14z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2F5",
    d: "M-1010-265H430V855h-1440z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h20v20H-1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.e687fe58c587e4322c6153904b5dca5c.svg";
export { ForwardRef as ReactComponent };